<template>
	<div class="workbenchAccessore">
		<div class="workbenchAccessore-teaser">
			<div class="controlCheckbox workbenchAccessore-checkbox">
				<input class="controlCheckbox-input" type="checkbox" :checked="checked" @change="check">
				<span class="controlCheckbox-state" @click="check" tabindex="0"></span>
			</div>
			<div class="workbenchAccessore-teaser-right">
				<img class="workbenchAccessore-img" v-if="item.image" :src="item.image" alt="" @click="showModal">
				<InputNumber class="workbenchAccessore-quantity" :modelValue="quantity" @update:modelValue="$emit('update:quantity', $event)" :min="1"></InputNumber>
			</div>
		</div>
		<div class="workbenchAccessore-body">
			<div class="workbenchAccessore-title">{{ item.text }}</div>
			<div class="workbenchAccessore-size">{{ item.height }} мм х {{ item.width }} мм х {{ item.depth }} мм</div>
			<div class="workbenchAccessore-price">{{ item.price }} ₽</div>
		</div>

		<div class="modal" v-if="isShowModal" @click.self="closeModal">
			<div class="modal-dialog">
				<div class="modal-header">
					<div class="modal-title">{{ item.text }}</div>
					<div class="modal-close" @click="closeModal"></div>
				</div>
				<div class="modal-body">
					<img v-if="item.image" :src="item.image" alt="">
					<div class="modal-content" v-html="item.description"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api';
import InputNumber from './InputNumber.vue';

export default defineComponent({
	components: {
		InputNumber,
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
		quantity: {
			type: Number,
			default: 1,
		},
		checked: {
			type: Boolean,
			default: true,
		},
	},
	setup(props, { emit }) {
		const isShowModal = ref(false);
		const check = () => { emit('update:checked', !props.checked) };
		const showModal = () => { isShowModal.value = true };
		const closeModal = () => { isShowModal.value = false };

		return {
			isShowModal,
			showModal,
			closeModal,
			check,
		};
	},
})
</script>
